import { isNullOrUndefined } from "$/utils/gates"

import { LocalStorageServiceKeys, StorageService } from "@/services"

export const isEnabledArchiveModal = (storage: StorageService) =>
    isNullOrUndefined(storage.getItem(LocalStorageServiceKeys.ArchiveModalVisible()))
